import React, { lazy, Suspense } from "react";
import LoginForm from "../../components/login/loginForm";
import { Helmet } from "react-helmet";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import "./login.css";
import CampaignIcon from "@mui/icons-material/Campaign";
import { yellow } from "@mui/material/colors";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import loginImg from "./login_img.png";
import { api_url } from "../../apiUtils";

const LazyLogoImage = () => (
  <img
    src={loginImg}
    alt="Login Logo"
    style={{
      width: "100%",
      height: "100vh",
      objectFit: "contain",
    }}
  />
);

function Login() {
  const [announcements, setAnnouncements] = React.useState([]);

  React.useEffect(() => {
    // Fetch announcements from the backend
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${api_url}user/get-announcement`); // Adjust your route
        const data = await response.json();
        console.log("data", data);
        setAnnouncements(data.getAnnouncement || []);
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
      }
    };

    fetchAnnouncements();

    const socket = io("http://localhost:80/");
    socket.on("connect", () => {
      console.log("Socket connected");
    });

    socket.on("announcement", (data) => {
      setAnnouncements((prev) => [...prev, data]);
      toast.success("New announcement received 🔔");
    });

    socket.on("updatedAnnouncement", (updatedData) => {
      setAnnouncements((prev) =>
        prev.map((item) => (item._id === updatedData._id ? updatedData : item))
      );
      toast.success("Announcement updated 🔔");
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  console.log("annoucneents", announcements);

  return (
    <>
      <Helmet>
        <title>Satta-Matka ( M-India ) Spot-Money | Login</title>
      </Helmet>
      <Box sx={{ mt: 4 }}>
        {/* Announcement Ticker */}
        <div className="ticker-container" style={{ display: "flex" }}>
          <div className="ticker">
            {announcements?.map((updates, index) => (
              <Typography
                key={index}
                sx={{
                  fontSize: 18,
                  letterSpacing: 1,
                  color: yellow[500],
                  whiteSpace: "nowrap",
                  mx: 4,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CampaignIcon
                  sx={{ mr: 0.5, fontSize: "1.3rem", color: "orangered" }}
                />
                {updates.message} {/* Add appropriate text to display */}
              </Typography>
            ))}
          </div>
        </div>

        <Grid container sx={{ position: "relative" }}>
          <Grid
            item
            md={7}
            xs={12}
            sx={{
              position: "relative",
              height: "100vh",
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Suspense fallback={<div>Loading...</div>}>
              <LazyLogoImage />
            </Suspense>
          </Grid>
          <Grid item md={5} xs={12} sx={{ position: "relative" }}>
            <Box
              sx={{
                display: "block",
                mt: { xs: 1, md: 0, lg: 7 },
              }}
            >
              <LoginForm />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Login;
